export function configRouter (router) {

  router.map({
    '/': {
      component: require('./components/jobs.vue')
    },
    '/jobs/:jobId': {
      component: require('./components/viewJob.vue')
    },
    '/applications/:uuid': {
      component: require('./components/viewApplication.vue')
    },
    'privacypolicy': {
      component: require('./components/privacypolicy.vue')
    },
    // Not found (404)
    '*': {
      component: require('./components/errors/404.vue')
    }
  });

  // redirect
  router.redirect({
  });
}



// WEBPACK FOOTER //
// ./src/routes.js